import Cookies from 'js-cookie'

// const TokenKey = 'Admin-Token'
const TokenKey = 'Admin-Token-'+process.env.VUE_APP_TITLE

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}
